/* tslint:disable */
/* eslint-disable */
// <auto-generated>
//   Generated using custom tool!
// </auto-generated>

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { DefaultAxiosInstance } from './DefaultAxiosInstance';
import { Try } from '../framework/Try';
import { INamedProperty } from './INamedProperty';

export async function analysis_concurrencyToken(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/Analysis/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function auth_info(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUserInfo>> {
  try {

        let url_ = "/api/Auth/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function auth_login(body: ILoginModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ILoginResponse>> {
  try {

        let url_ = "/api/Auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function auth_logout(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<void>> {
  try {

        let url_ = "/api/Auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function auth_endSession(userId: string, authId: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/Auth/session/{userId}/{authId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId)); 
        if (authId === undefined || authId === null)
            throw new Error("The parameter 'authId' must be defined.");
        url_ = url_.replace("{authId}", encodeURIComponent("" + authId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function auth_endAllSessions(userId: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/Auth/session/{userId}/all";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customersQuery_query(body: ICustomersQueryParams, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<ICustomer>>> {
  try {

        let url_ = "/api/CustomersQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customersQuery_single(body: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICustomer>> {
  try {

        let url_ = "/api/CustomersQuery/single";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function customersQuery_concurrencyToken(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/CustomersQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function dashboard_stats(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IDashboardStats>>> {
  try {

        let url_ = "/api/Dashboard/stats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function dashboard_concurrencyToken(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/Dashboard/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function holidayPeriodsCommand_new(body: IHolidayPeriodModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IHolidayPeriodModel>>> {
  try {

        let url_ = "/api/HolidayPeriodsCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function holidayPeriodsCommand_update(id: string, body: IHolidayPeriodModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IHolidayPeriodModel>>> {
  try {

        let url_ = "/api/HolidayPeriodsCommand/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function holidayPeriodsCommand_delete(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/HolidayPeriodsCommand/{id}/delete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function holidayPeriodsQuery_all(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IHolidayPeriod[]>>> {
  try {

        let url_ = "/api/HolidayPeriodsQuery/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function holidayPeriodsQuery_query(body: IHolidayPeriodsQueryParams, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IHolidayPeriod>>> {
  try {

        let url_ = "/api/HolidayPeriodsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function holidayPeriodsQuery_concurrencyToken(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/HolidayPeriodsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_new(body: IInventoryItemModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IInventoryItemModel>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_updateComment(id: string, body: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/InventoryItemsCommand/{id}/comment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_update(id: string, body: IInventoryItemUpdateModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IInventoryItemUpdateModel>>> {
  try {

        let url_ = "/api/InventoryItemsCommand/{id}/update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_updateStockLocation(id: string, body: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/InventoryItemsCommand/{id}/stockLocation";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_markAsUnusable(id: string, body: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/InventoryItemsCommand/{id}/markAsUnusable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsCommand_markAsUsable(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/InventoryItemsCommand/{id}/markAsUsable";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_query(body: IInventoryItemsQueryParams, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IInventoryItem>>> {
  try {

        let url_ = "/api/InventoryItemsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_taxonomies(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IConcurrencyData<IInventoryItemTaxonomies>>> {
  try {

        let url_ = "/api/InventoryItemsQuery/taxonomies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_queryAvailable(reservationId: string, reservationLineId: string | undefined, body: IAvailableInventoryItemsQueryParams, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IInventoryItemForReservationDto>>> {
  try {

        let url_ = "/api/InventoryItemsQuery/query/available/{reservationId}?";
        if (reservationId === undefined || reservationId === null)
            throw new Error("The parameter 'reservationId' must be defined.");
        url_ = url_.replace("{reservationId}", encodeURIComponent("" + reservationId)); 
        if (reservationLineId === null)
            throw new Error("The parameter 'reservationLineId' cannot be null.");
        else if (reservationLineId !== undefined)
            url_ += "reservationLineId=" + encodeURIComponent("" + reservationLineId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_single(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IInventoryItem>> {
  try {

        let url_ = "/api/InventoryItemsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function inventoryItemsQuery_concurrencyToken(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/InventoryItemsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function meta_build(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/meta/build";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function meta_ping(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<void>> {
  try {

        let url_ = "/api/meta/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function meta_url(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/meta/url";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function requestsCommand_new(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/RequestsCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function requestsCommand_updatePeriod(id: string, body: IPeriodModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPeriodModel>>> {
  try {

        let url_ = "/api/RequestsCommand/{id}/period";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function requestsCommand_updatePersonalInformation(id: string, body: IPersonalInformationModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPersonalInformationModel>>> {
  try {

        let url_ = "/api/RequestsCommand/{id}/personalInformation";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function requestsCommand_updateMaterial(id: string, body: IMaterialModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IMaterialModel>>> {
  try {

        let url_ = "/api/RequestsCommand/{id}/material";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function requestsCommand_confirm(id: string, body: boolean, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RequestsCommand/{id}/confirm";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function requestsCommand_resendEmailConfirmation(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/RequestsCommand/{id}/resendEmail";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function requestsQuery_single(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IRequest>> {
  try {

        let url_ = "/api/RequestsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function requestsQuery_prices(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IVipComfortTourSkiPrice>> {
  try {

        let url_ = "/api/RequestsQuery/{id}/prices";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsCommand_updatePersonalInformation(id: string, body: IPersonalInformationModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IPersonalInformationModel>>> {
  try {

        let url_ = "/api/ReservationsCommand/{id}/personalInformation";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsCommand_updateComment(id: string, body: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ReservationsCommand/{id}/comment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsCommand_updatePeriod(id: string, body: IReservationPeriodModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<IReservationPeriodModel>>> {
  try {

        let url_ = "/api/ReservationsCommand/{id}/period";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsCommand_updateWeightAndLength(id: string, body: ILengthWeightLevelModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUpdateResponse<ILengthWeightLevelModel>>> {
  try {

        let url_ = "/api/ReservationsCommand/{id}/weightAndLength";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsCommand_cancel(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ReservationsCommand/{id}/cancel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsCommand_deleteLine(id: string, lineId: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ReservationsCommand/{id}/lines/{lineId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (lineId === undefined || lineId === null)
            throw new Error("The parameter 'lineId' must be defined.");
        url_ = url_.replace("{lineId}", encodeURIComponent("" + lineId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsCommand_unlinkInventoryItem(id: string, lineId: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ReservationsCommand/{id}/lines/{lineId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (lineId === undefined || lineId === null)
            throw new Error("The parameter 'lineId' must be defined.");
        url_ = url_.replace("{lineId}", encodeURIComponent("" + lineId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsCommand_addReservationLine(id: string, body: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ReservationsCommand/{id}/lines/add";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsCommand_addOwnBoot(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ReservationsCommand/{id}/lines/add/ownBoot";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsCommand_handoverOwnBoot(id: string, lineId: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ReservationsCommand/{id}/lines/{lineId}/ownBoot/handover";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (lineId === undefined || lineId === null)
            throw new Error("The parameter 'lineId' must be defined.");
        url_ = url_.replace("{lineId}", encodeURIComponent("" + lineId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsCommand_undoHandoverOwnBoot(id: string, lineId: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ReservationsCommand/{id}/lines/{lineId}/ownBoot/handover/undo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (lineId === undefined || lineId === null)
            throw new Error("The parameter 'lineId' must be defined.");
        url_ = url_.replace("{lineId}", encodeURIComponent("" + lineId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsCommand_linkInventoryItem(id: string, lineId: string, body: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ReservationsCommand/{id}/lines/{lineId}/link";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (lineId === undefined || lineId === null)
            throw new Error("The parameter 'lineId' must be defined.");
        url_ = url_.replace("{lineId}", encodeURIComponent("" + lineId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsCommand_setReadyForRental(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ReservationsCommand/{id}/setReadyForRental";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsCommand_collect(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ReservationsCommand/{id}/collect";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsCommand_return(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ReservationsCommand/{id}/return";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsCommand_setPrice(id: string, body: number, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/ReservationsCommand/{id}/price";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsCommand_copy(id: string, body: ICopyReservationRequest, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<ICopyReservationRequest>>> {
  try {

        let url_ = "/api/ReservationsCommand/{id}/copy";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsQuery_query(body: IReservationsQueryParams, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IReservationDto>>> {
  try {

        let url_ = "/api/ReservationsQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsQuery_queryForInventoryItem(inventoryItemId: string, body: IReservationsQueryParams, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IReservationDto>>> {
  try {

        let url_ = "/api/ReservationsQuery/query/inventoryItem/{inventoryItemId}";
        if (inventoryItemId === undefined || inventoryItemId === null)
            throw new Error("The parameter 'inventoryItemId' must be defined.");
        url_ = url_.replace("{inventoryItemId}", encodeURIComponent("" + inventoryItemId)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsQuery_queryForCustomer(email: string | null, body: IReservationsQueryParams, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IReservationDto>>> {
  try {

        let url_ = "/api/ReservationsQuery/query/email/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email)); 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsQuery_concurrencyToken(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/ReservationsQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsQuery_single(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IReservationDto>> {
  try {

        let url_ = "/api/ReservationsQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsQuery_singleClientStatus(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IClientReservationDto>> {
  try {

        let url_ = "/api/ReservationsQuery/client/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsQuery_downloadBootLabel(id: string, lineId: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/ReservationsQuery/{id}/lines/{lineId}/label/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (lineId === undefined || lineId === null)
            throw new Error("The parameter 'lineId' must be defined.");
        url_ = url_.replace("{lineId}", encodeURIComponent("" + lineId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsQuery_contentLabel(id: string, lineId: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/ReservationsQuery/{id}/lines/{lineId}/label/content";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        if (lineId === undefined || lineId === null)
            throw new Error("The parameter 'lineId' must be defined.");
        url_ = url_.replace("{lineId}", encodeURIComponent("" + lineId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsQuery_downloadReservationTicket(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IFileResponse>> {
  try {

        let url_ = "/api/ReservationsQuery/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function reservationsQuery_ticketContent(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
  try {

        let url_ = "/api/ReservationsQuery/{id}/ticket/content";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockLocationsCommand_new(body: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/StockLocationsCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function stockLocationsQuery_isAvailable(name: string | null, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<boolean>> {
  try {

        let url_ = "/api/StockLocationsQuery/{name}/isAvailable";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_new(body: IUserModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<ICreateResponse<IUserModel>>> {
  try {

        let url_ = "/api/UsersCommand/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersCommand_delete(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
  try {

        let url_ = "/api/UsersCommand/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersQuery_query(body: IUsersQueryParams, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IQueryResult<IUserDto>>> {
  try {

        let url_ = "/api/UsersQuery/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json", 
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersQuery_single(id: string, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUserDto>> {
  try {

        let url_ = "/api/UsersQuery/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export async function usersQuery_concurrencyToken(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
  try {

        let url_ = "/api/UsersQuery/concurrencyToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            }
        };

        const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
        return new Try(r)
  } catch (error) {
    return new Try(undefined as any, error);
  }
}


export interface IUserInfo {
    id: string;
    name: string | undefined;
}

export interface ILoginModel {
    name: string | undefined;
    password: string | undefined;
}

export interface ILoginResponse {
    user: IUserInfo;
    errorName: string | undefined;
    errorPassword: string | undefined;
    hasError: boolean;
}

export interface IValidateResponse {
    error: string;
    hasError: boolean;
}

export interface IPageParams {
    index: number;
    size: number;
}

export interface ICustomersQueryParams {
    searchString: string;
    sortParams: ISortParams<ICustomer>;
    pageParams: IPageParams;
}

export interface ICustomer {
    email: string | undefined;
    created: Date;
    lastUpdated: Date;
    firstName: string | undefined;
    lastName: string | undefined;
    phoneNumber: string | undefined;
    address: string | undefined;
    dateOfBirth: Date;
    reservationIds: string[];
    countReservations: number;
    id: string | undefined;
    uniqueKey: string | undefined;
    searchField: string | undefined;
}

export interface ITypeDashboardStat {
    type: string | undefined;
    collectionDateAfter: Date;
    collectionDateBefore: Date;
    count: number;
}

export interface ITypeDashboardStats {
    in3Days: ITypeDashboardStat;
    in1Week: ITypeDashboardStat;
    in2Weeks: ITypeDashboardStat;
}

export interface IDashboardStats {
    countReservationsInWait: number;
    countReservationsCanBePrepared: number;
    countReservationsThisYear: number;
    revenuesThisYear: number;
    countRentedOut: number;
    statsSkis: ITypeDashboardStats;
    statsSnowboard: ITypeDashboardStats;
    statsTour: ITypeDashboardStats;
}

export interface IHolidayPeriodModel {
    name: string | undefined;
    fromDate: Date;
    toDate: Date;
}

export interface IHolidayPeriod {
    id: string;
    name: string | undefined;
    fromDate: Date;
    toDate: Date;
    formatted: string | undefined;
}

export interface IHolidayPeriodsQueryParams {
    sortParams: ISortParams<IHolidayPeriod>;
    pageParams: IPageParams;
    searchString: string;
    fromBefore: Date | undefined;
    fromAfter: Date | undefined;
    isUpcoming: boolean | undefined;
}

export interface IInventoryItemModel {
    type: string | undefined;
    brand: string | undefined;
    model: string | undefined;
    stockLocation: string | undefined;
    lengthInCm: number;
    size: number;
    specs: string | undefined;
}

export interface IInventoryItemUpdateModel {
    brand: string | undefined;
    model: string | undefined;
    lengthInCm: number;
    size: number;
    specs: string | undefined;
}

export interface IInventoryItemsQueryParams {
    searchString: string;
    sortParams: ISortParams<IInventoryItem>;
    pageParams: IPageParams;
    reservationStatuses: string[];
    stockLocations: string[];
    brands: string[];
    models: string[];
    types: string[];
    sizes: number[];
    lengths: number[];
}

export interface IReservationSummary {
    id: string;
    collectionDate: Date;
    fromDate: Date;
    toDate: Date;
    returnBeforeDate: Date;
    isPreparedForRental: boolean;
    isCollected: boolean;
}

export interface IInventoryItemTaxonomy {
    type: string | undefined;
    brand: string | undefined;
    model: string | undefined;
    size: number;
    lengthInCm: number;
}

export interface IInventoryItem {
    id: string;
    created: Date;
    lastUpdated: Date;
    type: string | undefined;
    stockLocation: string | undefined;
    brand: string | undefined;
    model: string | undefined;
    lengthInCm: number;
    size: number;
    upcomingOrCurrentReservations: IReservationSummary[];
    canSelect: boolean;
    unusableReason: string | undefined;
    comment: string | undefined;
    specs: string | undefined;
    taxonomy: IInventoryItemTaxonomy;
    orderedByCollectionDateUpcomingOrCurrentReservations: IReservationSummary[];
    firstUpcomingOrCurrentReservation: IReservationSummary;
    hasUnusableReason: boolean;
    reservationStatus: string | undefined;
    displayName: string | undefined;
    formattedDimensions: string | undefined;
    countUpcomingReservations: number;
    searchField: string | undefined;
    upcomingOrCurrentReservationIds: string[];
    isBoot: boolean;
    dimensionType: string | undefined;
    firstUpcomingOrCurrentReservationId: string | undefined;
    isPresentOrPreparedForRental: boolean;
    brandCommaModel: string | undefined;
}

export interface IInventoryItemTaxonomies {
    brands: string[];
    models: string[];
    skiBootSizes: number[];
    snowboardBootSizes: number[];
    skiTourBootSizes: number[];
    skiComfortLengths: number[];
    skiVipLengths: number[];
    skiTourLengths: number[];
    snowboardLengths: number[];
    skiJuniorLengths: number[];
    snowboardJuniorLengths: number[];
}

export interface IAvailableInventoryItemsQueryParams {
    sortParams: ISortParams<IInventoryItemForReservationDto>;
    pageParams: IPageParams;
    searchString: string;
    reservationStatuses: string[];
    stockLocations: string[];
    brands: string[];
    models: string[];
    sizes: number[];
    lengths: number[];
    isShowAll: boolean;
}

export interface IInventoryItemForReservationDto {
    id: string;
    canSelect: boolean;
    brandCommaModel: string | undefined;
    stockLocation: string | undefined;
    formattedDimensions: string | undefined;
    reservationStatus: string | undefined;
    lengthInCm: number;
    size: number;
}

export interface IPeriodModel {
    fromDate: Date;
    toDate: Date;
}

export interface IPersonalInformationModel {
    gender: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    address: string | undefined;
    dateOfBirth: Date;
    comments: string | undefined;
}

export interface IMaterialModel {
    lengthInCm: number;
    weightInKg: number;
    level: string | undefined;
    skiInventoryType: string | undefined;
    isSki: boolean;
    isSnowboardRightFootInFront: boolean;
    hasOwnBoots: boolean;
}

export interface IRequestLine {
    inventoryType: string | undefined;
    isOwnBoot: boolean;
    price: number;
}

export interface IRequest {
    id: string;
    created: Date;
    lastUpdated: Date;
    period: IPeriodModel;
    material: IMaterialModel;
    personalInformation: IPersonalInformationModel;
    lines: IRequestLine[];
    isPeriodSet: boolean;
    isMaterialSet: boolean;
    isPersonalInformationSet: boolean;
    collectionDate: Date | undefined;
    returnBeforeDate: Date | undefined;
    periodFromToFormatted: string | undefined;
    personalInfoFormatted: string | undefined;
    materialInfoFormatted: string | undefined;
    days: number;
    isJunior: boolean;
    totalPrice: number;
    confirmationNumber: string | undefined;
}

export interface IVipComfortTourSkiPrice {
    vipValue: number;
    comfortValue: number;
    tourValue: number;
}

export interface IReservationPeriodModel {
    collectionDate: Date;
    fromDate: Date;
    toDate: Date;
    returnBeforeDate: Date;
}

export interface ILengthWeightLevelModel {
    lengthInCm: number;
    weightInKg: number;
    level: string | undefined;
}

export interface ICopyReservationRequest {
    reservationId: string;
}

export interface IReservationsQueryParams {
    searchString: string;
    sortParams: ISortParams<IReservationDto>;
    pageParams: IPageParams;
    statuses: string[];
    createdBefore: Date | undefined;
    createdAfter: Date | undefined;
    fromDateBefore: Date | undefined;
    fromDateAfter: Date | undefined;
    collectionDateAfter: Date | undefined;
    collectionDateBefore: Date | undefined;
    isAlsoShowCancelled: boolean;
    keyFilterStatus: string | undefined;
    inventoryItemGroupTypes: string[];
    showReturned: boolean;
}

export interface IReservationLine {
    id: string;
    type: string | undefined;
    inventoryItemId: string | undefined;
    price: number;
    ownBootReference: string | undefined;
    isOwnBoot: boolean;
    isNextInLine: boolean;
    isOwnBootHandedOver: boolean;
    hasInventoryItem: boolean;
    isOwnBootOrSelected: boolean;
    isOwnBootHandedOverOrIsNextInLine: boolean;
}

export interface IReservationTransaction {
    date: Date;
    type: string | undefined;
}

export interface IReservation {
    id: string;
    created: Date;
    lastUpdated: Date;
    number: string | undefined;
    collectionDate: Date;
    fromDate: Date;
    toDate: Date;
    returnBeforeDate: Date;
    lines: IReservationLine[];
    overridePrice: number | undefined;
    weightInKg: number;
    lengthInCm: number;
    gender: string | undefined;
    email: string | undefined;
    phoneNumber: string | undefined;
    dateOfBirth: Date;
    address: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    comments: string | undefined;
    level: string | undefined;
    isSnowboardRightFootInFront: boolean | undefined;
    transactions: IReservationTransaction[];
    isCancelled: boolean;
    isPreparedForRental: boolean;
    isCollected: boolean;
    isReturned: boolean;
    canPrepareForRental: boolean;
    orderedTransactionTypes: string[];
    firstNameLastName: string | undefined;
    lastNameCommaFirstName: string | undefined;
    areAllLinesSelected: boolean;
    hasLines: boolean;
    searchField: string | undefined;
    calculatedPrice: number;
    isPriceOverride: boolean;
    dinOnePlus: number;
    dinTwoPlus: number;
    lengthSticksInCm: number;
    age: number;
    ageAtCreation: number;
    price: number;
    status: string | undefined;
    days: number;
    isFinished: boolean;
    inventoryItemIds: string[];
    canDeleteLine: boolean;
    canAddLine: boolean;
    canLinkLine: boolean;
    isJunior: boolean;
    canCancel: boolean;
    canEditPersonalInformation: boolean;
    canEditLengthAndWeight: boolean;
    canEditPeriod: boolean;
    inventoryItemGroupTypes: string[];
    hasSnowboardGroupType: boolean;
}

export interface IReservationLineWithInventoryItem {
    reservationLine: IReservationLine;
    inventoryItem: IInventoryItem;
}

export interface IReservationDto {
    id: string;
    item: IReservation;
    lines: IReservationLineWithInventoryItem[];
    created: Date;
    collectionDate: Date;
    number: string | undefined;
    firstNameLastName: string | undefined;
    clientStatus: string | undefined;
}

export interface IClientReservationLineDto {
    id: string;
    displayName: string | undefined;
    type: string | undefined;
    isOwnBoot: boolean;
    hasInventoryItem: boolean;
    price: number;
}

export interface IClientReservationDto {
    number: string | undefined;
    status: string | undefined;
    fromDate: Date;
    toDate: Date;
    collectionDate: Date;
    returnBeforeDate: Date;
    firstNameLastName: string | undefined;
    email: string | undefined;
    address: string | undefined;
    length: number;
    weight: number;
    discountedPrice: number;
    isSnowboardRightFootInFront: boolean | undefined;
    lines: IClientReservationLineDto[];
}

export interface IUserModel {
    name: string | undefined;
    password: string | undefined;
}

export interface IUsersQueryParams {
    searchString: string;
    sortParams: ISortParams<IUserDto>;
    pageParams: IPageParams;
}

export interface IUserDto {
    id: string;
    name: string | undefined;
}


export interface IQueryResult<T> {
    values: T[];
    unfilteredCount: number;
    filteredCount: number;
    pageIndex: number;
    pageSize: number;
    concurrencyToken: number;
    zeroBasedPageIndex: number;
    totalPages: number;
    currentFrom: number;
    currentTo: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}


export interface IObjectWithIdAndIdentifier<T> {
    id: T;
    identifier: string;
}


export interface IConcurrencyData<T> {
    value: T;
    concurrencyToken: number;
}


export interface ICreateResponse<T> {
    objectId: string;
    errors: IValidationError<T>[];
    hasError: boolean;
    isSuccess: boolean;
}


export interface IUpdateResponse<T> {
    errors: IValidationError<T>[];
    hasError: boolean;
    isSuccess: boolean;
}


export interface IValidationError<T> {
    property: string;
    error: string;
    zeroBasedIndex: number | undefined;
}


export interface IExportParams {
    mustApplyFilter: boolean;
    fileName: string;
    headers: INamedProperty[];
    format: string;
}


export interface ISortParams<T> {
    property: keyof T;
    direction: 'asc' | 'desc'
}

export type IFileResponse = { }

export type IBlob = { }


export type SubscriptionStatus = 'UpToDate' | 'ProcessingBacklog' | 'Down' | 'Unknown';
export const SubscriptionStatuses: SubscriptionStatus[] = ['UpToDate', 'ProcessingBacklog', 'Down', 'Unknown'];

export type DimensionType = 'Length' | 'Size';
export const DimensionTypes: DimensionType[] = ['Length', 'Size'];

export type Gender = 'Male' | 'Female' | 'Unknown';
export const Genders: Gender[] = ['Male', 'Female', 'Unknown'];

export type InventoryItemReservationStatus = 'Present' | 'PreparedForRental' | 'Rented';
export const InventoryItemReservationStatuses: InventoryItemReservationStatus[] = ['Present', 'PreparedForRental', 'Rented'];

export type InventoryType = 'SkiJunior' | 'SkiComfort' | 'SkiVip' | 'SkiTour' | 'Snowboard' | 'SnowboardJunior' | 'SkiBoot' | 'SkiBootTour' | 'SnowboardBoot';
export const InventoryTypes: InventoryType[] = ['SkiJunior', 'SkiComfort', 'SkiVip', 'SkiTour', 'Snowboard', 'SnowboardJunior', 'SkiBoot', 'SkiBootTour', 'SnowboardBoot'];

export type LevelType = 'Starter' | 'Medium' | 'Expert';
export const LevelTypes: LevelType[] = ['Starter', 'Medium', 'Expert'];

export type ReservationStatus = 'InWaitingLine' | 'WaitingOtherReservation' | 'CanBePrepared' | 'WaitingCollection' | 'Rented' | 'Returned' | 'Cancelled' | 'InProgress';
export const ReservationStatuses: ReservationStatus[] = ['InWaitingLine', 'WaitingOtherReservation', 'CanBePrepared', 'WaitingCollection', 'Rented', 'Returned', 'Cancelled', 'InProgress'];

export type ReservationTransactionType = 'PreparedForRental' | 'Collected' | 'Returned';
export const ReservationTransactionTypes: ReservationTransactionType[] = ['PreparedForRental', 'Collected', 'Returned'];

export type UnusableReason = 'Sold' | 'Stolen' | 'Other';
export const UnusableReasons: UnusableReason[] = ['Sold', 'Stolen', 'Other'];

export type ExportFormat = 'Xlsx' | 'Csv';
export const ExportFormats: ExportFormat[] = ['Xlsx', 'Csv'];

export type ReservationInventoryItemGroupType = 'Ski' | 'Snowboard' | 'TourSki';
export const ReservationInventoryItemGroupTypes: ReservationInventoryItemGroupType[] = ['Ski', 'Snowboard', 'TourSki'];